import edit_icons from './edit_icon.svg';
import delete_icons from './delete_icon.svg';
import dropdown_arrow_icons from './dropdown_arrow_icon.svg';
import show_password_icons from './show_password_icon.svg';
import hide_password_icons from './hide_password_icon.svg';
import add_user_icons from './add_user_icon.svg';
import view_icons from './view_icon.svg';
import add_icons from './add_icon.svg';
import total_audit_icons from './total_audit_icon.svg';
import pending_report_icons from './pending_report_icon.svg';
import plus_grey_icons from './plus_grey_icon.svg';
import add_user_grey_icons from './add_user_grey_icon.svg';
import back_icons from './back_icon.svg';
import download_icons from './download_icon.svg';
import graph_icons from './graph_icon.svg';
import forward_arrows from './forward_arrow.svg';



export const edit_icon = edit_icons;
export const delete_icon = delete_icons;
export const dropdown_arrow_icon = dropdown_arrow_icons;
export const show_password_icon = show_password_icons;
export const hide_password_icon = hide_password_icons;
export const add_user_icon = add_user_icons;
export const view_icon = view_icons;
export const add_icon = add_icons;
export const total_audit_icon = total_audit_icons;
export const pending_report_icon = pending_report_icons;
export const plus_grey_icon = plus_grey_icons;
export const add_user_grey_icon = add_user_grey_icons;
export const back_icon = back_icons;
export const download_icon = download_icons;
export const graph_icon = graph_icons;
export const forward_arrow = forward_arrows;



export { default as edit_primary_icon } from './edit_primary_icon.svg';
export { default as logo_icon } from './logo_icon.svg';
export { default as edit_green_icon } from './edit_green_icon.svg';
export { default as cross_icon } from './cross_icon.svg';
export { default as dashboard_icon } from './dashboard_icon.svg';
export { default as users_icon } from './users_icon.svg';
export { default as customers_icon } from './customers_icon.svg';
export { default as audits_icon } from './audits_icon.svg';
export { default as forms_icon } from './forms_icon.svg';
export { default as settings_icon } from './settings_icon.svg';
export { default as white_dashboard_icon } from './white_dashboard_icon.svg';
export { default as white_users_icon } from './white_users_icon.svg';
export { default as white_customers_icon } from './white_customers_icon.svg';
export { default as white_audits_icon } from './white_audits_icon.svg';
export { default as white_forms_icon } from './white_forms_icon.svg';
export { default as white_settings_icon } from './white_settings_icon.svg';
export { default as quick_action_icon } from './quick_action_icon.svg';
export { default as selected_audit_icon } from './selected_audit_icon.svg';
export { default as disselected_audit_icon } from './disselected_audit_icon.svg';
export { default as upload_icon } from './upload_icon.svg';
export { default as search_icon } from './search_icon.svg';
export { default as date_picker_icon } from './date_picker_icon.svg';

